import { RootState } from '../reducers';
import { NotificationState } from './reducer';

export const notificationsSelector = (state: RootState): NotificationState =>
  state.notifications;

export const getNotificationMsg = (state: RootState): string =>
  notificationsSelector(state).msg;
